__turbopack_context__.v({
  "accountHeader": "accountHeader-module-scss-module__9rskMG__accountHeader",
  "isActive": "accountHeader-module-scss-module__9rskMG__isActive",
  "navWrapper": "accountHeader-module-scss-module__9rskMG__navWrapper",
});
